import React, { memo, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Tab, Col, Row, Nav } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import moment from "moment-timezone";
import { SubNav } from "../layout/submenu";
import { getDrawingInstance } from "../map/geo/DrawingControl";
import { Unit } from "../../helpers/unit";
import {
  uuid,
  searchWord,
  usePermission,
  isToday,
  groupBy,
  GEO_SHAPE_TYPE,
} from "../../helpers/common";
import {
  saveRegion,
  saveRegionTitle,
  deleteRegions,
  selectRegions,
  activateRegion,
  deleteGeoShape,
  getGeoRegionWorkedDate,
  getGeoConfig,
} from "../../actions/geo";
import { farmStatsField } from "../../actions/farm";
import { getFarmCustomerList } from "../../actions/customer";
import {
  planAnalyzeInfo,
  analyzeParams,
  analyzeRecentSummary,
} from "../../actions/analyze";
import GeoRegionFilter from "./GeoRegionFilter";
import GeoCard from "./GeoCard";
import { toApiDateString } from "../../helpers/moment-ex";
import BulkEditModal from "./BulkEditModal";
import {
  toastWarn,
  toastInfo,
  showOverlay,
  hideOverlay,
} from "../../actions/toast";
import { Modal } from "../widgets";
import { Accordion } from "react-bootstrap";
import { GEO_MIME_TYPES, REGION_TYPE } from "../../constants";
import shp from "shpjs";
import { kml } from "@tmcw/togeojson";
import * as shapefile from "shapefile";
import GeoShapeModal from "./GeoShapeModal";
import MileageCountModal from "./MileageCountModal";
import { getUserInfo } from "../../helpers/session";
import {
  getGeoRegionObj,
  getSelectedRegionId,
  setGeoRegionObj,
  setSelectedRegionId,
  removeItem,
  selectedRegionIdKey,
  geoRegionObjKey,
  getFarmInfo,
  setGeoRegionList,
  geoRegionListKey
} from "../../helpers/session";
import { getIndexData, storeIndexData } from "../../helpers/indexedDBUtils";

const GeoRegionSubList = (props) => {
  const dispatch = useDispatch();
  const scrollContainerRef = useRef(null);

  const isMapLoaded = useSelector((state) => state.map.isMapLoaded);
  const isMapFetching = useSelector((state) => state.map.isFetching);

  const timezone = useSelector(
    (state) => state.farm.currentFarm.timezone_identifier
  );
  const regionsList2 = useSelector((state) => state.geo.regionsList);
  const selectedRegionIds = useSelector((state) => state.geo.selectedRegionIds);
  const search = useSelector((state) => state.analyze.searchParams);
  const settings = useSelector((state) => state.user.settings);
  const farmSettings = useSelector(state => state.farm.farmSettings.farm_config);
  const isStretchTableEnabled = (farmSettings && farmSettings.stretch_table && farmSettings.stretch_table.visible) ? farmSettings.stretch_table.visible : false;
  const selectedPlanTypeId = useSelector(
    (state) => state.plan.selectedPlanType
  );

  const farmInfo = getFarmInfo();
  const farmId = farmInfo.farm_uuid;

  const unit = Unit.getInstance();
  const searchInput = React.createRef();
  let timerId = "";

  const [tabs] = useState([
    { id: 1, label: "All", regionTypeIds: null, name: "All" },
    { id: 2, label: "Field", regionTypeIds: [2], name: "Field" },
    { id: 3, label: "Offload", regionTypeIds: [4], name: "Offload" },
    { id: 4, label: "Transload", regionTypeIds: [14], name: "Transload" },
    //{ id: 5, label: "ROI", regionTypeIds: [9],  name: "All"  },
    { id: 6, label: "Crop", withCropName: true, name: "Crop" },
    {
      id: 7,
      label: "Removed",
      inactive: true,
      name: "Removed",
      color: "#ffcd38",
    },
  ]);
  const [drawing, setDrawing] = useState(null);
  const [geoRegionId, setGeoRegionId] = useState(-1);
  const [isEditMode, setIsEditMode] = useState(false);
  const [isScrollBottom, setIsScrollBottom] = useState(false);
  const [state, setState] = useState({
    activeTab: 1,
    searchText: "",
    filterIds: null,
    selectedRegionIds: [],
    regionById: {},
    isManualSelect: false,
    startDate: null,
    openBulkEditModal: false,
    deleteModal: false,
    deleteName: "",
    deleteId: "",
    deleteItem: "",
    bulkDelete: false,
    startList: 0,
    endList: 20,
    bulkRestore: false,
    isRegionUpdating: false,
    confirmButton: {},
    inactiveRegion: "",
    activateModal: false,
    isRemoveButton: true,
    newShapes: [],
    tempShapes: [],
    isNewRegion: false,
    isIgnore: false,
    isOverwrite: false,
    title: {
      name: "Untitled",
      type: 2,
      disableType: false,
      cropName: "",
      customerId: null,
      startDate: moment(),
    },
    selectedViewType: 1,
    importShapeTabs: [
      { value: 1, label: "Import as List (Recommended)" },
      { value: 2, label: "Import as Group" },
    ],
    showMileageModal: false,
  });
  const setGeoRegionObjRef = useRef(setState);

  useEffect(() => {
    setGeoRegionObjRef.current = setState;
  }, [setGeoRegionObjRef]);

  useEffect(() => {
    const { current: scrollContainer } = scrollContainerRef;
    if (scrollContainer) {
      scrollContainer.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (scrollContainer) {
        scrollContainer.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  const regionsList = useMemo(() => {
    if (regionsList2 && regionsList2.length > 0) {
      //setGeoRegionList(regionsList2);
      storeIndexData('geoRegionList', regionsList2)
      return regionsList2;
    } else {
      storeIndexData('geoRegionList', [])
      setGeoRegionList([]);
      return [];
    }
  }, [regionsList2, state.startList, state.endList]);

  useEffect(() => {
    searchInput.current.focus();
    // this.farmId = props.match.params.farmId;
    // this.farmId && dispatch(planAnalyzeInfo(this.farmId));
    initDrawingTools();

    if (!drawing || !drawing.google.maps.geometry) {
      timerId = setInterval(() => {
        if (!drawing || !drawing.google.maps.geometry) return;
        clearInterval(timerId);
        timerId = null;
        findFieldArea();
      }, 2 * 1000);
    } else findFieldArea();

    if (regionsList.length === 0) return;
    preSelect();
    regionAnalyzeInfo(selectedRegionIds ? selectedRegionIds : []);
    return () => {
      const geoRegionObj = getGeoRegionObj();
      if (timerId) clearInterval(timerId);
      const draw = drawing ? drawing : getDrawingInstance();
      if (!draw) return;
      draw.removeListenerByName("geo");
      draw.close();

      dispatch(
        selectRegions(
          geoRegionObj.isManualSelect
            ? geoRegionObj.selectedRegionIds
            : selectedRegionIds
        )
      );
      removeItem(selectedRegionIdKey);
      removeItem(geoRegionObjKey);
      removeItem(geoRegionListKey);
      if (!geoRegionObj.isManualSelect)
        draw.showShapeGroups(
          regionsList.map((e) => e.geo_region_uuid),
          true
        );

    };
  }, []);

  useEffect(() => {
    regionAnalyzeInfo([]);
    findFieldArea();
    preSelect();
    initDrawingTools();
  }, [search.custom, selectedPlanTypeId, selectedRegionIds, isMapLoaded]);

  useEffect(() => {
    if (
      Object.entries(state.regionById).length === 0 &&
      regionsList &&
      regionsList.length > 0
    ) {
      findFieldArea();
    }
  }, [state, state.regionById]);

  const handleScroll = () => {
    const { current: scrollContainer } = scrollContainerRef;
    if (scrollContainer) {
      const { scrollTop, clientHeight, scrollHeight } = scrollContainer;
      if (scrollTop + clientHeight >= scrollHeight - 10) {
        setIsScrollBottom(true);
      } else {
        setIsScrollBottom(false);
      }
    }
  };

  useEffect(() => {
    if (isScrollBottom) {
      setState({ ...state, endList: state.endList + 20 });
    }
  }, [isScrollBottom]);

  useEffect(() => {
    findFieldArea();
  }, [drawing && drawing.google.maps.geometry, regionsList2, isMapFetching]);

  const getShapeDetails = async (regionId, shapeId, location) => {
    let tareFactor = 0;
    let shapeUuid = null;
    let isLocationModified = false;
    let indexedRegion = await getIndexData('geoRegionList');
    indexedRegion = (indexedRegion && indexedRegion.length > 0) ? indexedRegion : [];
    const regions = (regionsList && regionsList.length > 0) ? regionsList : indexedRegion;
    regions.forEach((item) => {
      if (regionId === item.geo_region_uuid)
        item.shapes.forEach((e) => {
          if (e.geo_shape_object_uuid === shapeId) {
            tareFactor = e.tare_factor;
            shapeUuid = e.geo_shape_uuid;
            if (location.length === e.location.length) {
              for (const [index] of location.entries()) {
                if (
                  !(
                    location[index].lat === e.location[index].lat &&
                    location[index].lng === e.location[index].lng
                  )
                )
                  isLocationModified = true;
              }
            } else {
              isLocationModified = true;
            }
          }
        });
    });

    return { isLocationModified, shapeUuid, tareFactor };
  };

  const getNewShapeDetails = (
    newShapes,
    currentRegionId,
    geoRegionName,
    title
  ) => {
    return newShapes[geoRegionName].map((item, index) => {
      const { isLocationModified, shapeUuid, tareFactor } = getShapeDetails(
        currentRegionId,
        item.shapeId,
        item.location
      );
      return {
        status: item.status,
        geo_shape_uuid: shapeUuid,
        shape_name:
          item.name === "Untitled" ? `${title.name} #${index + 1}` : item.name,
        geo_shape_object_uuid: item.shapeId,
        geo_shape_type: item.type,
        properties: { ...item.properties, others: title.others },
        location: item.location,
        tare_factor: item.tare_factor
          ? Number(item.tare_factor)
          : Number(tareFactor),
        is_modified_location: isLocationModified,
      };
    });
  };

  const initDrawingTools = async () => {
    if (!isMapLoaded) return;
    if (!drawing) setDrawing(getDrawingInstance());
    if (!drawing) return;
    const allow = usePermission();
    const isAllowEdit = isToday(search.range)
      ? allow("geo-region", "edit")
      : false;

    if (drawing && drawing._events && !drawing._events["shapes_loaded"]) {
      drawing.addListener("shapes_loaded", "geo", () => {
        //preSelect();
        preSelectForListener();
      });
    }

    if (drawing && drawing._events && !drawing._events["unsupported-file"]) {
      drawing.addListener("unsupported-file", (message) => {
        dispatch(toastWarn(message || "Incorrect file type"));
      });
    }

    if (drawing && drawing.events && !drawing.events["geo"]["save"]) {
      isAllowEdit &&
        drawing.addListener("save", "geo", ({ title }) => {
          dispatch(showOverlay({ text: "Uploading..." }));

          const currentFarmInfo = getFarmInfo();
          const currentFarmId = currentFarmInfo.farm_uuid;

          const geoRegionObj = getGeoRegionObj();
          const { selectedViewType, isNewRegion, isOverwrite } = geoRegionObj;
          const { variety } = title;
          setGeoRegionObjRef.current({
            ...geoRegionObj,
            isRegionUpdating: true,
          });
          const shapes = [];
          let currentRegionId = getSelectedRegionId();
          const shapeGeo = drawing.getShapeGeo(currentRegionId);
          for (const shapeId in shapeGeo) {
            const item = shapeGeo[shapeId];
            item["status"] = drawing.isRegEdit
              ? item.status === 0
                ? 2
                : item.status
              : item.status;
            if (item.status === 0) continue;
            item["shapeId"] = shapeId;
            shapes.push(item);
          }

          const newShapes =
            selectedViewType === 1 && isNewRegion
              ? shapes
              : groupBy("folder_name")(shapes);
          const newShapesLength =
            selectedViewType === 1 && isNewRegion
              ? newShapes.length
              : Object.keys(newShapes).length;
          let isNotify = false;

          for (var i = 0; i < newShapesLength; i++) {
            if (newShapesLength === i + 1) isNotify = true;
            let shape = newShapes[i];
            let geoRegionName =
              selectedViewType === 1 && isNewRegion
                ? shape.name
                : Object.keys(newShapes)[i];
            let geoRegionTypeId =
              selectedViewType === 1 &&
                isNewRegion &&
                [GEO_SHAPE_TYPE.MARKER].includes(shape.type)
                ? 11
                : title.type;

            let cropName, varietyName, cropYear = null;
            if (isNewRegion && shape && shape.properties && shape.properties.others) {
              cropName = shape.properties.others.EnterpriseDescription || title.cropName;
              varietyName = shape.properties.others.VarietyDescription || variety;
              cropYear = shape.properties.others.CropYear || null;
            } else {
              cropName = title.cropName;
              varietyName = variety;
              cropYear = title.cropYear || null;
            }

            let data = {
              farm_uuid: currentFarmId,
              geo_region_uuid:
                currentRegionId === -1 ? uuid() : currentRegionId,
              geo_region_name:
                geoRegionName === "Untitled" ? title.name : geoRegionName,
              crop_name: cropName,
              crop_year: cropYear,
              customer_uuid: geoRegionTypeId === 2 ? title.customerId : null,
              geo_region_type_id: geoRegionTypeId,
              start_date: title.startDate
                ? toApiDateString(title.startDate)
                : null,
              is_overwrite: isOverwrite,
              shapes:
                selectedViewType === 1 && isNewRegion
                  ? [
                    {
                      status: shape.status,
                      geo_shape_object_uuid: shape.shapeId,
                      shape_name:
                        shape.name === "Untitled" ? title.name : shape.name,
                      geo_shape_type: shape.type,
                      properties: {
                        ...shape.properties,
                        ...title.others ? { others: title.others } : {},
                      },
                      location: shape.location,
                      tare_factor: shape.tare_factor,
                      is_modified_location: false,
                      geo_shape_uuid: null,
                    },
                  ]
                  : getNewShapeDetails(
                    newShapes,
                    currentRegionId,
                    geoRegionName,
                    title
                  ),
              variety: varietyName,
            };
            const regionTypeId = data.geo_region_type_id;

            if (regionTypeId === 17 && data.shapes.length >= 2) {
              const routePath = drawing.routePath[data.geo_region_uuid]
                ? drawing.routePath[data.geo_region_uuid].map((e, index) => ({
                  lat: e.lat(),
                  lng: e.lng(),
                  sequence: index + 1,
                }))
                : [];
              if (routePath.length > 0) {
                data["shapes"] = [
                  {
                    ...data.shapes[0],
                    location: routePath,
                    geo_shape_type: "polyline",
                    properties: {
                      strokeColor: "#0000FF",
                      strokeWeight: 3,
                      strokeOpacity: 1,
                    },
                  },
                ];
              }
            }
            dispatch(saveRegion(data, isNotify, search.custom));
            setGeoRegionId(-1);
            setSelectedRegionId(-1);
            currentRegionId = -1;
            drawing.acceptChanges();
          }
          setTimeout(() => {
            setGeoRegionObjRef.current({
              ...geoRegionObj,
              selectedRegionIds: [],
              isRegionUpdating: false,
              newShapes: [],
              isNewRegion: false
            });
            dispatch(hideOverlay());
          }, 1000);
        });
    }

    if (drawing && drawing.events && !drawing.events["geo"]["title_save"]) {
      isAllowEdit &&
        drawing.addListener("title_save", "geo", ({ title }) => {
          const currentFarmInfo = getFarmInfo();
          const currentFarmId = currentFarmInfo.farm_uuid;

          let currentRegionId = getSelectedRegionId();
          let showLog = false;
          if (showLog) {
            console.log(geoRegionId, "geoRegionId");
          }
          const { variety } = title;
          drawing.editShapeGroupDetail(title, currentRegionId);
          if (!isEditMode) return;
          const data = {
            farm_uuid: currentFarmId,
            geo_region_uuid: currentRegionId,
            geo_region_name: title.name,
            crop_name: title.cropName,
            customer_uuid: title.customerId,
            geo_region_type_id: title.type,
            start_date: title.startDate
              ? toApiDateString(title.startDate)
              : null,
            shapes: [],
            variety,
          };
          dispatch(saveRegionTitle(data));
        });
    }
    if (drawing && drawing.events && !drawing.events["geo"]["shape_dblclick"]) {
      isAllowEdit &&
        drawing.addListener("shape_dblclick", "geo", ({ shapeGroupId }) => {
          const findRegion = regionsList.filter(
            (e) => e.geo_region_uuid === shapeGroupId
          );
          if (findRegion.length === 0) return;
          handleEdit(findRegion[0]);
        });
    }

    if (farmId) dispatch(getGeoConfig({ farm_uuid: farmId }));
  };

  useEffect(() => {
    if (drawing) {
      preSelect();
    }
    //if (drawing && drawing.events && !drawing.events["geo"]) {
    initDrawingTools();
    //}
  }, [drawing]);

  useEffect(() => {
    setGeoRegionObj(state);
  }, [state]);

  const preSelect = () => {
    const selectedRegionIds2 =
      selectedRegionIds && farmId ? selectedRegionIds : [];
    if (drawing) drawing.showShapeGroups(selectedRegionIds2, true);
    setState({ ...state, selectedRegionIds: selectedRegionIds2 });
  };

  const preSelectForListener = () => {
    const geoRegionObj = getGeoRegionObj();
    const selectedRegionIds2 =
      geoRegionObj && geoRegionObj.selectedRegionIds && farmId
        ? geoRegionObj.selectedRegionIds
        : [];
    if (drawing) drawing.showShapeGroups(selectedRegionIds2, true);
    setState({ ...geoRegionObj, selectedRegionIds: selectedRegionIds2 });
  };

  const findFieldArea = () => {
    if (!(drawing && drawing.google.maps.geometry)) return;
    const google = drawing.google;
    const regionById = {};
    for (const region of regionsList) {
      const regionAcres = {
        area: 0,
        shapes: {},
      };

      for (const shape of region.shapes) {
        if (shape.geo_shape_type.toLowerCase() !== "polygon") continue;
        const areaPath = shape.location.map(
          (e) => new google.maps.LatLng(e.lat, e.lng)
        );
        const shapeAcres = parseFloat(
          (
            google.maps.geometry.spherical.computeArea(areaPath) * 0.00024711
          ).toFixed(2)
        );
        regionAcres.area += shapeAcres;
        regionAcres.shapes[shape.geo_shape_uuid] = shapeAcres;
      }

      regionById[region.geo_region_uuid] = regionAcres;
    }
    setState({ ...state, regionById });
  };

  const toggle = (tab) => {
    if (state.activeTab !== tab)
      setState({ ...state, activeTab: tab, selectedRegionIds: [] });
  };

  const handleAdd = () => {
    if (!drawing) return;
    handleSelect(-1, false);
    setIsEditMode(false);
    const newId = uuid();
    setGeoRegionId(newId);
    setSelectedRegionId(newId);

    drawing
      .reset()
      .discard()
      .editableShapeGroup(newId)
      .open({
        name: "Untitled",
        cropName: "",
        variety: "",
        customerId: null,
        startDate: moment.utc().tz(timezone),
        type: 2,
        disableType: false,
        farmGeoConfig: {},
      });
  };

  const handleEdit = (item) => {
    if (!drawing) return;

    setIsEditMode(true);
    setGeoRegionId(item.geo_region_uuid);
    setSelectedRegionId(item.geo_region_uuid);

    setState({ ...state, selectedRegionIds: [item.geo_region_uuid] });
    showShapeGroups(state.filterIds, [item.geo_region_uuid]);

    const variety = item.variety ? item.variety : "";
    const others =
      item.shapes.length > 0 && item.shapes[0].properties
        ? item.shapes[0].properties.others
        : null;

    drawing
      .reset()
      .discard()
      .editableShapeGroup(item.geo_region_uuid)
      .open({
        name: item.geo_region_name,
        cropName: item.crop_name ? item.crop_name : "",
        variety,
        customerId: item.customer_uuid ? item.customer_uuid : null,
        startDate: item.start_date ? moment.utc(item.start_date) : null,
        type: item.geo_region_type_id,
        disableType: false,
        farmGeoConfig: { ...others },
      });
  };

  const handleBulkEdit = (isOpen) => {
    setState({ ...state, openBulkEditModal: isOpen });
  };

  const handleSearchBox = (searchText) => {
    setState({ ...state, searchText });
  };

  const handleSelect = (id, event) => {
    const { selectedRegionIds } = state;
    const checked = typeof event === "boolean" ? event : event.target.checked;
    if (id === -1) {
      const { regionList } = getFilteredList(true);
      if (checked) {
        regionList.forEach((e) => {
          if (selectedRegionIds.indexOf(e.geo_region_uuid) < 0)
            selectedRegionIds.push(e.geo_region_uuid);
        });
      } else {
        regionList.forEach((e) => {
          const indexOf = selectedRegionIds.indexOf(e.geo_region_uuid);
          if (indexOf >= 0) selectedRegionIds.splice(indexOf, 1);
        });
      }
      showShapeGroups(state.filterIds, selectedRegionIds);
      setState({ ...state, selectedRegionIds, isManualSelect: true });
    } else {
      const indexOf = selectedRegionIds.indexOf(id);

      if (checked && indexOf < 0) selectedRegionIds.push(id);
      else if (!checked && indexOf >= 0) selectedRegionIds.splice(indexOf, 1);

      showShapeGroups(state.filterIds, selectedRegionIds);
      setState({ ...state, selectedRegionIds, isManualSelect: true });
    }

    regionAnalyzeInfo(selectedRegionIds);
  };

  const regionAnalyzeInfo = (selectedRegionIds) => {
    const { regionById } = state;
    if (selectedRegionIds && selectedRegionIds.length !== 0) {
      const selectedRegionId = selectedRegionIds[selectedRegionIds.length - 1];
      const selecteRegion = regionsList.filter(
        (e) => e.geo_region_uuid === selectedRegionId
      );

      if (
        selecteRegion.length === 0 ||
        !selecteRegion[0] ||
        ![2, 4].includes(selecteRegion[0].geo_region_type_id)
      ) {
        dispatch(planAnalyzeInfo(farmId));
        dispatch(
          analyzeRecentSummary({
            replayBox: null,
            workWindow: null,
          })
        );
      } else {
        dispatch(farmStatsField(null));
        dispatch(
          analyzeParams({
            regionId: selectedRegionId,
            shapeId:
              regionById &&
                regionById[selectedRegionId] &&
                regionById[selectedRegionId].shapes &&
                regionById[selectedRegionId].shapes.length > 0
                ? Object.keys(regionById[selectedRegionId].shapes)[0]
                : selectedRegionId,
            title:
              selecteRegion.length !== 0
                ? selecteRegion[0].geo_region_name
                : null,
          })
        );
        dispatch(
          getGeoRegionWorkedDate({
            farm_uuid: farmId,
            geo_region_uuid: selectedRegionId,
            plan_type_id: selectedPlanTypeId,
          })
        );
        dispatch(getFarmCustomerList({ farm_uuid: farmId }));
      }
    } else {
      setState({ ...state, selectedRegionIds: [] });
      dispatch(farmStatsField(null));
      dispatch(planAnalyzeInfo(farmId));
      dispatch(
        analyzeRecentSummary({
          replayBox: null,
          workWindow: null,
        })
      );
    }
  };

  const overlayHideCb = () => {
    setState({
      ...state,
      selectedRegionIds: [],
      deleteModal: false,
      bulkDelete: false,
      bulkRestore: false,
      activateModal: false,
    });
    dispatch(hideOverlay());
  };

  const bulkDeleteCb = () => {
    dispatch(hideOverlay());
    setState({
      ...state,
      bulkDelete: false,
      deleteModal: false,
      selectedRegionIds: [],
    });
  };

  const bulkRestoreCb = () => {
    dispatch(hideOverlay());
    setState({ ...state, bulkRestore: false, selectedRegionIds: [] });
  };

  const handleConfirm = (item) => {
    if (item && item.crew_list) {
      const message =
        item.crew_list && item.crew_list.includes("\t")
          ? item.crew_list
            .split("\t")
            .filter((value, index, self) => self.indexOf(value) === index)
            .toString()
          : item.crew_list;
      dispatch(
        toastWarn(`Region is part of crew ${message} and cannot be removed. `, {
          position: "top-left",
        })
      );
    } else {
      setState({
        ...state,
        deleteId: farmId,
        deleteName: item.geo_region_name,
        deleteModal: true,
        isRemoveButton: item.isRemoveButton,
        deleteItem: item.geo_region_uuid,
      });
    }
  };

  const handleDelete = () => {
    state.bulkDelete
      ? dispatch(
        deleteRegions(
          {
            farm_uuid: farmId,
            geo_region_uuid: state.selectedRegionIds,
          },
          bulkDeleteCb,
          search.custom
        )
      )
      : dispatch(
        deleteRegions(
          {
            farm_uuid: farmId,
            geo_region_uuid: state.deleteItem,
          },
          overlayHideCb,
          search.custom
        )
      );
  };

  const handleActivateConfirm = (item) => {
    setState({
      ...state,
      deleteName: item.geo_region_name,
      inactiveRegion: item.geo_region_uuid,
      activateModal: true,
    });
  };

  const handleActivate = (item) => {
    state.bulkRestore
      ? dispatch(
        activateRegion(
          {
            farm_uuid: farmId,
            geo_region_uuid: state.selectedRegionIds,
          },
          bulkRestoreCb,
          search.custom
        )
      )
      : dispatch(
        activateRegion(
          {
            farm_uuid: farmId,
            geo_region_uuid: state.inactiveRegion,
          },
          overlayHideCb,
          search.custom
        )
      );
  };

  const handleInactive = () => {
    state.bulkDelete
      ? dispatch(
        deleteRegions(
          {
            farm_uuid: farmId,
            geo_region_uuid: state.selectedRegionIds,
            is_inactivate: true,
          },
          bulkDeleteCb,
          search.custom
        )
      )
      : dispatch(
        deleteRegions(
          {
            farm_uuid: farmId,
            geo_region_uuid: state.deleteItem,
            is_inactivate: true,
          },
          overlayHideCb,
          search.custom
        )
      );
  };

  const handleConfirmAll = () => {
    const regList = regionsList;
    const selectedReg = state.selectedRegionIds;

    const crew_list =
      selectedReg && regList && selectedReg.length > 0 && regList.length > 0
        ? regList
          .filter(
            (item) =>
              item.geo_region_uuid &&
              item.crew_list &&
              selectedReg.includes(item.geo_region_uuid)
          )
          .map((item) => item.crew_list.split("\t"))
          .flat()
          .filter((value, index, self) => self.indexOf(value) === index)
        : [];

    if (crew_list && crew_list.length > 0) {
      dispatch(
        toastWarn(
          `Selected region is part of crew ${crew_list.toString()} and cannot be removed. `,
          {
            position: "top-left",
          }
        )
      );
      return;
    }
    const updatedState = {
      ...state,
      deleteModal: true,
      bulkDelete: true,
      deleteId: "",
      deleteName: "",
      isRemoveButton: false,
    };

    if (state.activeTab !== 7) {
      setState({ ...updatedState, isRemoveButton: true });
    } else {
      setState(updatedState);
    }
  };

  const handleRestoreAll = () => {
    setState({
      ...state,
      deleteName: "",
      bulkRestore: true,
      activateModal: true,
    });
  };

  const handleFocusToShape = (item, e) => {
    e.stopPropagation();
    if (!drawing) return;
    drawing.setBounds(item.geo_region_uuid);
  };

  const handleFocusToSubShape = (e, item) => {
    if (!drawing) return;
    drawing.setBoundsForShape(item.geo_shape_uuid);
  };

  const handleDeleteToSubShape = (item) => {
    const geoShapId = item.geo_shape_uuid;
    dispatch(
      deleteGeoShape({
        farm_id: farmId,
        geo_shape_uuid: geoShapId,
        range: search.custom,
      })
    );
  };

  const handleFilter = (filterIds) => {
    filterIds = filterIds ? filterIds : null;
    setState({ ...state, filterIds });
    showShapeGroups(filterIds, state.selectedRegionIds);
  };

  const showShapeGroups = (filterIds, selectedRegionIds) => {
    const selectedIds = filterIds
      ? selectedRegionIds.filter((e) => filterIds.indexOf(e) >= 0)
      : selectedRegionIds;
    drawing.showShapeGroups(selectedIds || [], true);
  };

  const renderRegionList = (params) => {
    let { regionList, selectedIds, today, isAllowEdit, isAllowDelete } = params;
    const { regionById } = state;
    const { areaShortName } = settings;
    regionList = regionList.slice(state.startList, state.endList);
    return (
      <div>
        <Accordion>
          {regionList.map((e) => {
            const selected = selectedIds.indexOf(e.geo_region_uuid) >= 0;
            const filteredList = regionList.filter(
              (item) => item.geo_region_uuid === e.geo_region_uuid
            );
            const area = regionById[e.geo_region_uuid]
              ? convertArea(regionById[e.geo_region_uuid].area)
              : 0;

            return (
              <React.Fragment key={e.geo_region_uuid}>
                <SubNav.List>
                  <GeoCard
                    key={e.geo_region_uuid}
                    item={{ ...e, area }}
                    selected={selected}
                    areaShortName={areaShortName}
                    isToday={today}
                    isAllowEdit={isAllowEdit}
                    isAllowDelete={isAllowDelete}
                    isMapLoaded={isMapLoaded}
                    showBulkEdit={
                      state.activeTab !== 1 && selectedIds.length > 0
                    }
                    onSelect={handleSelect}
                    onClickEdit={handleEdit}
                    onClickActivate={handleActivateConfirm}
                    onClickDelete={handleConfirm}
                    onClickFocus={handleFocusToShape}
                    onClickBulkEdit={handleBulkEdit}
                    expand={area}
                    eventKey={e.geo_region_uuid}
                  />
                </SubNav.List>
                <Accordion.Collapse
                  eventKey={e.geo_region_uuid}
                  className="pl-2"
                >
                  {renderList(filteredList, areaShortName, {
                    today,
                    isAllowDelete,
                  })}
                </Accordion.Collapse>
              </React.Fragment>
            );
          })}
        </Accordion>
      </div>
    );
  };

  const convertArea = (value) => {
    return unit.toArea(value || 0, 2);
  };

  const renderList = (item, areaShortName, { today, isAllowDelete }) => {
    const list = item.filter((e) => e.shapes.length > 0);
    return (
      <div className="mb-2">
        {list.map((e) => {
          const shape = (e.shapes || []).map((e) => e);
          const shapeAcres =
            (state.regionById[e.geo_region_uuid] || {}).shapes || {};

          return shape.map((item, index) => (
            <Row key={index}>
              <Col className="ml-3 col-11">
                <SubNav.Item className="highlight eg-card">
                  <SubNav.Card>
                    <span className="float-right btn-action-group">
                      <i
                        className="fa fa-binoculars mr-3"
                        title="Focus"
                        onClick={() => handleFocusToSubShape(this, item)}
                      />
                      {today && (
                        <>
                          {isAllowDelete && (
                            <SubNav.DeleteButton
                              onClick={() => handleDeleteToSubShape(item)}
                            />
                          )}
                        </>
                      )}
                    </span>
                    <SubNav.Name bullet={true}>
                      {item.geo_shape_name}
                    </SubNav.Name>
                    <SubNav.Display2>
                      {areaShortName}:{" "}
                      {convertArea(shapeAcres[item.geo_shape_uuid])}
                    </SubNav.Display2>
                  </SubNav.Card>
                </SubNav.Item>
              </Col>
            </Row>
          ));
        })}
      </div>
    );
  };

  const getFilteredList = (isSearchText) => {
    let allRegions = regionsList;
    let filteredList = allRegions;
    // let filteredList = allRegions.filter(e => e.alive);

    const { filterIds } = state;
    const activeTab = parseInt(state.activeTab);
    const findTabs = tabs.filter((e) => e.id === activeTab);
    const regionTypeIds =
      findTabs.length > 0 ? findTabs[0].regionTypeIds : null;
    const withCropName = findTabs.length > 0 ? findTabs[0].withCropName : null;
    const inactive = findTabs.length > 0 ? findTabs[0].inactive : null;

    if (regionTypeIds)
      filteredList = filteredList.filter(
        (e) => regionTypeIds.indexOf(e.geo_region_type_id) >= 0
      );
    if (withCropName) filteredList = filteredList.filter((e) => e.crop_name);
    if (filterIds)
      filteredList = filteredList.filter(
        (e) => filterIds.indexOf(e.geo_region_uuid) >= 0
      );
    if (inactive) filteredList = allRegions.filter((e) => !e.active);

    const selectedIds = filteredList
      .map((e) => e.geo_region_uuid)
      .filter((id) => state.selectedRegionIds.indexOf(id) >= 0);

    if (isSearchText) {
      const { searchText } = state;
      if (searchText.trim().length > 0)
        filteredList = filteredList.filter(
          (e) =>
            searchWord(e.geo_region_name, searchText) ||
            searchWord(e.crop_name, searchText) ||
            searchWord(e.customer_name, searchText)
        );
    }
    const isSelectAll = filteredList.length === selectedIds.length;

    return { regionList: filteredList, selectedIds, isSelectAll };
  };

  const handleChooseFile = () => {
    if (!drawing) return;
    handleSelect(-1, false);
    setIsEditMode(false);
    const newRegionId = uuid();
    setGeoRegionId(newRegionId);
    setSelectedRegionId(newRegionId);

    drawing
      .reset()
      .discard()
      .editableShapeGroup(newRegionId);

    const input = document.querySelector("#file-upload");
    if (input) input.click();
  };

  const parseDescriptionHtml = (htmlString) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');

    const result = {};

    // Select rows inside the inner table
    const rows = doc.querySelectorAll('table table tr');
    rows.forEach((row) => {
      const cells = row.querySelectorAll('td');
      if (cells.length === 2) {
        const key = cells[0].textContent.trim();
        const value = cells[1].textContent.trim();
        result[key] = value === '<Null>' ? null : value;
      }
    });

    return result;
  }

  const formatShapeProperties = async (geojson) => {
    const processedGeoJson = {
      ...geojson,
      features: geojson.features.map((feature) => {
        let props = { ...feature.properties };

        if (
          props.description &&
          typeof props.description === 'string' &&
          props.description.includes('<html')
        ) {
          try {
            props = { ...props, ...parseDescriptionHtml(props.description) };
            if ('description' in props) {
              delete props.description;
            }
          } catch (err) {
            console.error('Failed to parse description:', err);
          }
        }

        return {
          ...feature,
          properties: props
        };
      })
    };
    return processedGeoJson;
  }

  const handleFileChange = (e) => {
    e.preventDefault();
    if (!(e.target && e.target.files && e.target.files.length > 0)) return;
    const file = e.target.files[0];
    const reader = new FileReader();
    const fileParts = file.name.split(".");
    const fileExtension =
      fileParts.length > 0 ? fileParts[fileParts.length - 1] : null;
    const zipFileExtension = [
      "application/x-compressed",
      "application/x-zip-compressed",
      "application/zip",
      "multipart/x-zip",
    ];

    if (zipFileExtension.includes(file.type)) {
      reader.onload = (e) => {
        shp(e.target.result)
          .then(async (geojson) => {
            const structureShpGeoJSON = await drawing.plugins.file.structureShpGeoJSON(
              geojson
            );
            sendImportedShapeFilesGeo(structureShpGeoJSON);
          })
          .catch(() =>
            drawing.emit("unsupported-file", "File must contain *.shp file")
          );
      };
      reader.readAsArrayBuffer(file);
    } else if (
      file.type === "application/vnd.google-earth.kml+xml" ||
      fileExtension === "kml"
    ) {
      reader.onload = async (e) => {
        const kmlFile = new DOMParser().parseFromString(
          e.target.result,
          "text/xml"
        );
        const geojson = kml(kmlFile);
        if (!geojson || geojson.features.length === 0)
          return dispatch(toastInfo("No shapes in imported file"));
        const updatedGeojson = await formatShapeProperties(geojson);
        const geoShapJson = await drawing.plugins.file.addFolderName(
          kmlFile,
          updatedGeojson
        );
        sendImportedShapeFilesGeo(geoShapJson);
      };
      reader.readAsText(file);
    } else if (fileExtension === "shp") {
      const me = this;
      reader.onload = (e) => {
        shapefile
          .open(e.target.result)
          .then((source) =>
            source.read().then((result) => {
              if (result.done) return;
              me.sendImportedShapeFilesGeo(result.value);
            })
          )
          .catch(() => drawing.emit("unsupported-file"));
      };

      reader.readAsArrayBuffer(file);
    } else drawing.emit("unsupported-file");
    setState({ ...state, isImportKml: true });
  };

  const sendImportedShapeFilesGeo = async (geoShapJson) => {
    await drawing.plugins.file.importFile(geoShapJson);
    if (drawing.newShapes.length !== 0) {
      const newGeoRegions = await groupGeoregionShape(drawing.newShapes);
      if (newGeoRegions.length !== 0) {
        let newGeoRegionShapes = [];
        for (const region of newGeoRegions) {
          let geo =
            regionsList.lengt === 0
              ? []
              : regionsList.filter(
                (geoRegion) => geoRegion.geo_region_name === region.geo_region
              );
          if (geo.length === 0) region["isAlready"] = false;
          else region["isAlready"] = true;

          if (region.shapes.length !== 0) {
            for (const shape of region.shapes) {
              let geo =
                regionsList.lengt === 0
                  ? []
                  : regionsList.filter(
                    (geoRegion) => geoRegion.geo_region_name === shape.name
                  );
              if (geo.length === 0) shape["isAlready"] = false;
              else shape["isAlready"] = true;
            }
          }
          newGeoRegionShapes.push(region);
        }
        setState({
          ...state,
          newShapes: newGeoRegionShapes,
          isNewRegion: true,
        });
      }
    }
    //shapesIgnore(state.isIgnore, state.isOverwrite);
  };

  const groupGeoregionShape = (geoRegions) => {
    const folderNameGroup = groupBy("folder_name")(geoRegions);
    const geoRegionShape = [];
    for (let i = 0; i < Object.keys(folderNameGroup).length; i++) {
      let geoRegionId = null;
      let shapes =
        Object.keys(folderNameGroup)[i].lengt === 0
          ? []
          : folderNameGroup[Object.keys(folderNameGroup)[i]].map((shape) => {
            geoRegionId = shape.shapeGroupId;
            return {
              name: shape.shape.name,
              id: shape.shape.id,
            };
          });
      geoRegionShape.push({
        geo_region: Object.keys(folderNameGroup)[i],
        geoRegionId,
        shapes,
      });
    }
    return geoRegionShape;
  };

  const saveRegions = () => {
    drawing.emit("save", { title: state.title });
    setState({
      ...state,
      isNewRegion: false,
      selectedViewType: 1,
      isRegionUpdating: false,
      tempShapes: []
    });
  };

  const discardRegions = () => {
    setState({
      ...state,
      isNewRegion: false,
      selectedViewType: 1,
      tempShapes: [],
    });
    drawing.discard();
  };

  const setSelectedViewType = (type) =>
    setState({ ...state, selectedViewType: type });

  const handleIgnore = (isIgnore) => shapesIgnore(isIgnore, false);

  const handleOverride = (isOverwrite) => {
    setState({ ...state, isOverwrite });
    shapesIgnore(false, isOverwrite);
  };

  const shapesIgnore = (isIgnore, isOverwrite) => {
    const { newShapes } = state;
    if (isIgnore) {
      const removedShapes = [];
      for (const region of newShapes) {
        let shapes = [];
        for (const shape of region.shapes) {
          if (shape.isAlready) drawing.removeShapeFromList(shape);
          else shapes.push(shape);
        }
        removedShapes.push({
          ...region,
          shapes,
        });
      }
      setState({ ...state, tempShapes: removedShapes, isIgnore, isOverwrite });
    } else {
      for (const geo of drawing.newShapes) {
        drawing.addShapeToList(geo.shape);
      }
      setState({
        ...state,
        newShapes: newShapes,
        tempShapes: [],
        isIgnore,
        isOverwrite,
      });
    }
  };

  /* const renderPlacesNumber = (regionLength, endListNo) => {
        if (regionLength > 0) {
            if (regionLength >= endListNo) {
                return `(${endListNo}/${regionLength})`;
            } else {
                return `(${regionLength})`;
            }
        } else {
            return ""
        }
    } */

  const handleMilageModal = (isOpen) => {
    setState({
      ...state,
      showMileageModal: isOpen,
    });
  };

  {
    const {
      activeTab,
      searchText,
      isRegionUpdating,
      selectedRegionIds /* , endList */,
    } = state;
    const { regionList, selectedIds, isSelectAll } = getFilteredList(true);
    const rootUrl = `/home/farm/${farmId}`;
    const fieldTypeById = {};
    for (const item of regionList) {
      if (!fieldTypeById[item.geo_region_type_id])
        fieldTypeById[item.geo_region_type_id] =
          item.geo_region_type_description;
    }
    const today = isToday(search.range);
    const allow = usePermission();
    const isAllowCreate =
      isMapLoaded && today ? allow("geo-region", "create") : false;
    const isAllowEdit = allow("geo-region", "edit");
    const isAllowDelete = allow("geo-region", "delete");
    const OffloadRegion =
      regionList && regionList.length > 0
        ? regionList.filter(
          (item) => item.geo_region_type_id === REGION_TYPE.OFFLOADSITE
        )
        : [];
    const fieldRegion =
      regionList && regionList.length > 0
        ? regionList.filter(
          (item) =>
            item.geo_region_type_id === REGION_TYPE.FIELD ||
            item.geo_region_type_id === REGION_TYPE.TRANSLOADSITE
        )
        : [];
    let isDistance =
      fieldRegion &&
      fieldRegion.length > 0 &&
      OffloadRegion && OffloadRegion.length > 0;

    let userInfo = getUserInfo();
    const loginId = userInfo && userInfo.loginId;
    let isUserIdAccess = loginId.includes('acuitusag');

    return (
      <>
        <SubNav>
          <SubNav.Subheader>
            <div className="title-container">
              <aside className="section-title">
                <NavLink to={`${rootUrl}/shape/list`}>
                  Places {regionList.length > 0 ? `(${regionList.length})` : ""}
                  <i className="fa fa-angle-right section-right-arrow"></i>
                </NavLink>
                {/* <NavLink to={`${rootUrl}/shape/list`}>
                                    Places {renderPlacesNumber(regionList.length, endList)}<i className="fa fa-angle-right section-right-arrow"></i>
                                </NavLink> */}
              </aside>
              <aside className="section-icon-container">
                {isStretchTableEnabled && isDistance && (
                  <button
                    type="button"
                    className="hand-symbol btn-add px-0"
                    onClick={() => handleMilageModal(true)}
                  >
                    <i className="fa fa-calculator"></i>
                  </button>
                )}
                {isAllowCreate && <SubNav.AddButton onClick={handleAdd} />}
                {isAllowCreate && (
                  <>
                    <input
                      id="file-upload"
                      style={{ display: "none" }}
                      accept={GEO_MIME_TYPES.join(",")}
                      type="file"
                      onChange={handleFileChange}
                      onClick={(e) => {
                        const { target = {} } = e || {};
                        target.value = "";
                      }}
                    />
                    <SubNav.ImportButton
                      title={`*.zip(must contain:  *.shp)  (or)  *.shp  (or)  *.kml`}
                      onClick={handleChooseFile}
                    />
                  </>
                )}
                {isAllowDelete &&
                  selectedRegionIds.length > 0 &&
                  !isRegionUpdating && (
                    <SubNav.DeleteButton
                      title="Delete all"
                      className="delete-all"
                      onClick={handleConfirmAll}
                    />
                  )}
                {isAllowDelete &&
                  activeTab === 7 &&
                  selectedRegionIds.length > 0 &&
                  !isRegionUpdating && (
                    <SubNav.ActivateButton
                      title="Restore all"
                      className="restore-all"
                      onClick={handleRestoreAll}
                    />
                  )}
              </aside>
            </div>
          </SubNav.Subheader>

          <div className="geo-search-input">
            <SubNav.SearchBox
              ref={searchInput}
              placeholder="Place, Crop and Customer name"
              value={searchText}
              onChange={(e) => handleSearchBox(e.target.value)}
              onClear={() => handleSearchBox("")}
            />
          </div>

          <Tab.Container defaultActiveKey="1">
            <Nav variant="tabs">
              {tabs.map((e) => (
                <Nav.Item key={e.id}>
                  <Nav.Link
                    style={{ color: e.color }}
                    eventKey={e.id}
                    title={e.name}
                    onClick={() => toggle(e.id)}
                  >
                    {e.label}
                  </Nav.Link>
                </Nav.Item>
              ))}
              <Nav.Item>
                <GeoRegionFilter
                  regionsList={regionsList}
                  onFilter={handleFilter}
                />
              </Nav.Item>
            </Nav>

            <Tab.Content>
              <Tab.Pane
                eventKey={activeTab}
                className="scroll-bar-2 accord-top"
                ref={scrollContainerRef}
              >
                {regionList.length === 0 && <SubNav.NotFound />}
                {regionList.length > 0 && (
                  <SubNav.List>
                    <SubNav.Item className="item-checkbox geo-select-all pt-2">
                      <Row className="p-0 m-0 pb-1">
                        <Col lg={1} md={1} sm={1} className="p-0 m-0">
                          <SubNav.Checkbox
                            checked={isSelectAll}
                            onChange={handleSelect.bind(this, -1)}
                          />
                        </Col>
                        <Col lg={8} md={8} sm={8} className="p-0 m-0">
                          <SubNav.Link to={props.match.url}>All</SubNav.Link>
                        </Col>
                      </Row>
                    </SubNav.Item>
                    {Object.keys(fieldTypeById).map((fieldTypeId) => {
                      const groupList = regionList.filter(
                        (e) => e.geo_region_type_id === parseInt(fieldTypeId)
                      );
                      return (
                        <div key={fieldTypeId}>
                          {activeTab === 1 && groupList.length > 0 && (
                            <div className="field-type-divider">
                              <span>{fieldTypeById[fieldTypeId]}</span>
                            </div>
                          )}
                          {renderRegionList({
                            regionList: groupList,
                            selectedIds,
                            today,
                            isAllowEdit,
                            isAllowDelete,
                          })}
                        </div>
                      );
                    })}
                  </SubNav.List>
                )}
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>

          <Modal.Confirm
            show={state.deleteModal}
            onConfirm={handleDelete}
            iconClassName="fa fa-trash"
            inactiveButton={
              state.isRemoveButton && { onInActive: handleInactive }
            }
            confirmButton={{ content: "Delete" }}
            cancelButton={{ content: "Cancel" }}
            body={
              state.isRemoveButton ? (
                <>
                  {" "}
                  Do you really want to remove or delete{" "}
                  <b>{state.deleteName}</b> region?{" "}
                </>
              ) : (
                <>
                  {" "}
                  Do you really want to delete <b>
                    {state.deleteName}
                  </b> region?{" "}
                </>
              )
            }
            onHide={() =>
              setState({
                ...state,
                deleteModal: false,
                bulkDelete: false,
                bulkRestore: false,
              })
            }
          />

          <Modal.Confirm
            show={state.activateModal}
            className="modal-info"
            onConfirm={handleActivate}
            onHide={() => setState({ ...state, activateModal: false })}
            confirmButton={{ variant: "info" }}
            iconClassName="fa fa-undo restore"
            body={
              <>
                Do you want to restore <b>{state.deleteName}</b> region?{" "}
              </>
            }
          />
        </SubNav>
        {state.openBulkEditModal && (
          <BulkEditModal
            fieldType={tabs.find((item) => item.id === activeTab)}
            farmId={farmId}
            selectedRegionIds={selectedIds}
            onHide={() => handleBulkEdit(false)}
          />
        )}

        {state.newShapes.length !== 0 ? (
          <GeoShapeModal
            isNewRegion={state.isNewRegion}
            saveRegions={saveRegions}
            discardRegions={discardRegions}
            setSelectedViewType={setSelectedViewType}
            selectedViewType={state.selectedViewType}
            tabs={state.importShapeTabs}
            newRegions={
              state.isIgnore
                ? state.tempShapes.length === 0
                  ? state.newShapes
                  : state.tempShapes
                : state.newShapes
            }
            isIgnore={state.isIgnore}
            isOverwrite={state.isOverwrite}
            handleIgnore={handleIgnore}
            handleOverride={handleOverride}
          />
        ) : (
          <div></div>
        )}

        {state.showMileageModal && farmId !== 'dc4e522a-ac96-11ea-9459-42010a8a0046' && (
          <MileageCountModal onHide={() => handleMilageModal(false)} userIdAccess={isUserIdAccess} />
        )}
      </>
    );
  }
};

export default memo(GeoRegionSubList);
